import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgEmailTemplates,
  createOrgEmailTemplate,
  updateOrgEmailTemplate,
  deleteOrgEmailTemplate,
} from '../../../lib/requests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgEmailTemplatesRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_EMAIL_TEMPLATES_REQUEST);
    try {
      var response = yield call(getOrgEmailTemplates, request.payload);
      yield put(actions.getOrgEmailTemplatesSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgEmailTemplatesFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgEmailTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_EMAIL_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        createOrgEmailTemplate,
        request.payload.organization_guid,
        request.payload
      );
      yield put(actions.createOrgEmailTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.createOrgEmailTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgEmailTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_EMAIL_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        updateOrgEmailTemplate,
        request.payload.guid,
        request.payload.organization_guid,
        request.payload
      );
      yield put(actions.updateOrgEmailTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.updateOrgEmailTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgEmailTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_EMAIL_TEMPLATE_REQUEST);
    try {
      yield call(
        deleteOrgEmailTemplate,
        request.payload.guid,
        request.payload.organization_guid
      );
      yield put(actions.deleteOrgEmailTemplateSuccess(request.payload.guid));
    } catch (e) {
      yield put(actions.deleteOrgEmailTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
